import React from 'react';
import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import DrawService from './service/DrawService';
import GeocoderForm from './component/geocoderForm';

export class GeocoderPlugin {
  constructor(mymap, options = {}) {
    this.map = mymap;

    const defaultFileTypesLinks = {
      address: 'https://cdn.sogefi-web.com/interne/images/files-exemples/geocoder/adresse.csv',
      point: 'https://cdn.sogefi-web.com/interne/images/files-exemples/geocoder/point.csv',
      parcel: 'https://cdn.sogefi-web.com/interne/images/files-exemples/geocoder/parcelle.csv'
    };

    const {
      api_collection,
      api_pci,
      ban_uri,
      user_data,
      embedded = false,
      containerId = null,
      featureGroup = null,
      iddCollectionSelected  = null,
      fileTypesLinks = {},
      zoomPadding = { paddingTopLeft: [800, 0] },
      onValidateEntite = null,
      onReloaEntite = null
    } = options;

    // Merge les valeurs par défaut avec celles passées par l'utilisateur
    this.fileTypesLinks = { ...defaultFileTypesLinks, ...fileTypesLinks };

    if (containerId) {
      this._renderReact(`#${containerId}`, api_collection, api_pci, ban_uri, user_data,  this.fileTypesLinks, iddCollectionSelected,containerId,embedded,onValidateEntite, onReloaEntite);
    }else{
      throw new Error("l'id du conteneur est requis.");
    }

    this.featureGroup = featureGroup || L.featureGroup();

    DrawService.init(this.map,this.featureGroup, { zoomPadding });
   
  }

  _renderReact(selector, api_collection, api_pci, ban_uri, user_data, fileTypesLinks, iddCollectionSelected, containerId, embedded,onValidateEntite, onReloaEntite) {
    const container = document.querySelector(selector);
    container.innerHTML = "";
    const root = ReactDOM.createRoot(container);
    root.render(
      <RecoilRoot>
        <GeocoderForm 
          api_collection={api_collection}
          api_pci={api_pci}
          ban_uri={ban_uri}
          user_data={user_data}
          fileTypesLinks={fileTypesLinks}
          iddCollectionSelected={iddCollectionSelected}
          containerId={containerId}
          embedded={embedded}
          onValidateEntite={onValidateEntite}
          onReloaEntite={onReloaEntite}
        />
      </RecoilRoot>
    );
  }
  
}

window.GeocoderPlugin = GeocoderPlugin;
